<div class="container-fluid quote-detail zero-padding">
  <div class="row">
    <div class="tab col-lg-3 col-md-3 col-sm-3">
      <button
        class="tablinks"
        id="defaultOpen"
        #defaultOpen
        (click)="openTab($event, categoryOne)"
      >
        <i class="material-icons custom-margin-right-icon">assignment</i>
        {{ "quoteTracking.quoteSummary" | cxTranslate }}
      </button>
      <button class="tablinks" (click)="openTab($event, categoryTwo)">
        <i class="material-icons custom-margin-right-icon">description</i>
        {{ "quoteTracking.associatedDoc" | cxTranslate }}
      </button>
      <button class="tablinks" (click)="openTab($event, categoryThree)">
        <i class="material-icons custom-margin-right-icon">rate_review</i>
        {{ "quoteTracking.quoteInquiry" | cxTranslate }}
      </button>
      <button class="tablinks" (click)="openTab($event, categoryFour)">
        <i class="icons line-item custom-margin-right-icon"></i>
        {{ "quoteTracking.lineItems" | cxTranslate }}({{ quoteDetail?.quoteLineDetails.length }})
      </button>
    </div>
    <div class="col-lg-9 col-md-9 col-sm-9">
      <div id="categoryOne" #categoryOne class="tabcontent">
        <div *ngIf="quoteDetail$ | async as quoteDetail; else loading">
          <div class="row custom-last-child-margin">
            <div class="col-md-12 content">
              <h5 class="tabcontent-display-line-section-heading title">
                <i class="material-icons custom-margin-right-icon"
                  >assignment</i
                >
                {{ "quoteTracking.quoteSummary" | cxTranslate }}
                <span class="heading-extras">
                  <span class="info-item" *ngIf="distinct?.length === 1">
                    {{ "quoteTracking.hashOrder" | cxTranslate }}<b>{{ distinct[0] }}</b>
                  </span>
                  <span class="info-item">
                    {{ "quoteTracking.quoteOrder" | cxTranslate }}<b>{{ quoteDetail?.quoteDetailsList.quoteId }}</b>
                  </span>
                  <span class="info-item">
                    {{ "quoteTracking.quoteStatus" | cxTranslate }}
                    <span
                      class="status-label"
                      [ngClass]="quoteDetail?.quoteDetailsList.quoteStatusCode"
                    >
                      {{ quoteDetail?.quoteDetailsList.quoteStatusLabel }}</span
                    >
                  </span>
                </span>
              </h5>
            </div>
            <div class="col-md-12 bottom-space">
              <vs-status-bubble
                [currentStatusIndex]="currentOrderStatusId"
                [statusType]="currentStatus"
                [isReturned]="isReturned"
              >
              </vs-status-bubble>
            </div>
            <div class="col-md-12 customer-info">
              <div class="row">
                <div class="col-sm-4 col-md-4 col-lg-4 pr-0">
                  <div>
                    {{ "quoteTracking.quoteTotal" | cxTranslate }}
                     <b>{{ getNetPrice( quoteDetail?.quoteDetailsList.quoteTotal)}}</b>
                  </div>
                  <div class="width-max overflow-ellipsis">
                    {{ "quoteTracking.customerReference" | cxTranslate }}
                    <b>{{ quoteDetail?.quoteDetailsList.quoteReference }}</b>
                  </div>
                  <div class="width-max overflow-ellipsis">
                    {{ "quoteTracking.quoteCreated" | cxTranslate }}
                    <b>{{ quoteDetail?.quoteDetailsList.quoteCreatedBy }}</b>
                  </div>
                  <div
                    class="width-max"
                    *ngIf="
                      quoteDetail?.quoteDetailsList.csrComments !== undefined &&
                      quoteDetail?.quoteDetailsList.csrComments !== null &&
                      quoteDetail?.quoteDetailsList?.csrComments?.length > 0
                    "
                  >
                  {{ "quoteTracking.csrComments" | cxTranslate }}
                    <b class="csr-cmnt-desc">{{
                      quoteDetail?.quoteDetailsList.csrComments
                    }}</b>
                  </div>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-4 pr-0 dateContent">
                  <div>
                    {{ "quoteTracking.quoteCreation" | cxTranslate }}
                    <b>{{
                      quoteDetail?.quoteDetailsList.createdDate
                        | date: "dd MMM yyyy"
                    }}</b>
                  </div>
                  <div>
                    {{ "quoteTracking.orderType" | cxTranslate }}
                    <b>{{
                      getOrderTypeValue(quoteDetail?.quoteDetailsList?.rfqType)
                    }}</b>
                  </div>
                  <div>
                    {{ "quoteTracking.quoteExpDate" | cxTranslate }}
                    <b>{{
                      quoteDetail?.quoteDetailsList.expirationDate
                        | date: "dd MMM yyyy"
                    }}</b>
                  </div>
                </div>

                <div class="col-sm-4 col-md-4 col-lg-4 pr-0">
                  <div class="download-btn-container">
                    <div class="download-txt" (click)="downloadPDF()">
                      <i class="download"></i>
                      {{ 'quoteTracking.downloadPDF' | cxTranslate }}
                    </div>
                    <div class="download-txt" (click)="downloadEXCEL()">
                      <i class="download"></i>
                      {{ 'quoteTracking.downloadEXCEL' | cxTranslate }}
                    </div>
                  </div>
                  <div
                    class="btn-sec"
                    *ngIf="
                      (checkUserEnabled(accessibility.QUOTABILITYFLAG)
                        | async) && quoteDetail?.isEditQuote === false && quoteDetail?.isOfflineQuote === true
                    "
                  >
                    <a
                      class="btn vs-tertiary-btn repeat-order"
                      (click)="openModal()"
                    >
                      <span class="material-icons icon-repeat-size"
                        >receipt</span
                      >
                      {{ "quoteTracking.repeatQuote" | cxTranslate }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- && quoteDetail?.isEditQuote === true -->
          <vs-quote-pending-action
            *ngIf="
              ((checkUserEnabled(accessibility.QUOTABILITYFLAG) | async) ||
                (checkUserEnabled(accessibility.SELLABILITYFLAG) | async)) &&
              quoteDetail?.quoteDetailsList.quoteStatusCode ===
                CurrentQuoteStatus.PENDING &&
              quoteDetail?.isEditQuote === false &&
              quoteDetail?.isAcceptQuote === false &&
              quoteDetail?.isAdditionalQuote === false &&
              !quoteDetail?.isMergeQuote
            "
            [quoteId]="quoteId"
            [dateObject]="dateObject"
            >{{ "quoteTracking.pending" | cxTranslate }}</vs-quote-pending-action
          >

          <div class="row">
            <div class="col-md-12 tariff-verbiage-div">
              <span>
                This <b>quote</b> is subject to adjustment in the event that new tariffs are implemented, existing tariffs are
                increased, or in case of any increase to the costs of materials or other costs that would affect Baker Hughes’ costs
                or its supply chain, whether directly or indirectly. Baker Hughes reserves the right to adjust pricing to reflect cost
                impacts. Baker Hughes will provide notification of any increase.
              </span>
            </div>
          </div>

          <div class="row custom-last-child-margin">
            <div class="col-md-12 add-content">
              <h5 class="tabcontent-display-line-section-heading">
                {{ "quoteTracking.addressDetails" | cxTranslate }}
              </h5>
            </div>
            <div class="col-md-12">
              <vs-address-line
                [address]="quoteDetail?.quoteDetailsList"
              ></vs-address-line>
            </div>
          </div>
          <div class="row custom-last-child-margin">
            <div class="col-md-12 add-content">
              <h5 class="tabcontent-display-line-section-heading">
                {{ "quoteTracking.lineItems" | cxTranslate }}
                <span
                  class="expand-txt"
                  (click)="expandAll = !expandAll"
                  [ngClass]="{ expanded: expandAll }"
                >
                  <i class="material-icons keyboard-arrow"
                    >keyboard_arrow_down</i
                  >
                  <span *ngIf="!expandAll">{{ "quoteTracking.expand" | cxTranslate }}</span>
                  <span *ngIf="expandAll">{{ "quoteTracking.collapse" | cxTranslate }}</span>
                </span>
              </h5>
            </div>
            <div class="col-md-12">
              <vs-line-items
                [lineItems]="quoteDetail?.quoteLineDetails"
                [expandAll]="expandAll"
              ></vs-line-items>
            </div>
          </div>
        </div>
      </div>
      <div id="categoryTwo" #categoryTwo class="tabcontent">
        <div class="row custom-last-child-margin">
          <div class="col-md-12 add-content">
            <h5 class="tabcontent-display-line-section-heading title">
              <em class="material-icons custom-margin-right-icon"
                >description</em
              >
              {{ "quoteTracking.associatedDoc" | cxTranslate }}
              <span
                *ngIf="!this.noAttachment"
                class="download-all-txt"
                [ngClass]="downloadAllLoader ? 'disabled' : ''"
                (click)="downloadAllFiles()"
                ><em class="icons download"></em>{{ "quoteTracking.download" | cxTranslate }}
              </span>
              <div
                *ngIf="downloadAllLoader"
                class="product-search-spinner cx-spinner"
              >
                <cx-spinner></cx-spinner>
              </div>
            </h5>
          </div>
          <div
            class="col-lg-12 col-md-12 col-sm-12 mt-4 blocked-warning-message"
            *ngIf="this.noAttachment"
          >
            <span class="obsolete-text">
              <em class="material-icons">info</em>
              <strong>&nbsp; {{ "quoteTracking.info" | cxTranslate }} </strong>&nbsp; {{ "quoteTracking.noDocAvailable" | cxTranslate }}</span
            >
          </div>
          <div class="col-md-12">
            <div *ngIf="!this.noAttachment">
              <div
                class="col-lg-12 col-md-12 col-sm-12 mt-4"
                *ngFor="let documentItem of this.attachments; let i = index"
              >
                <div class="upload-block">
                  <span
                    class="material-icons vertical-middle"
                    [ngClass]="downloadLoader[i] ? 'disabled' : ''"
                    >insert_drive_file</span
                  >
                  <a
                    (click)="downloadDocument(documentItem, i)"
                    [ngClass]="downloadLoader[i] ? 'disabled' : ''"
                    >{{ generateFileName(documentItem) }}</a
                  >
                  <div
                    *ngIf="downloadLoader[i]"
                    class="product-search-spinner cx-spinner"
                  >
                    <cx-spinner></cx-spinner>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="documentDownloadingLoader">
              <div class="cx-spinner">
                <cx-spinner></cx-spinner>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="categoryThree" #categoryThree class="tabcontent">
        <div class="row custom-last-child-margin">
          <div class="col-md-12 add-content">
            <h5 class="tabcontent-display-line-section-heading title">
              <i class="material-icons custom-margin-right-icon">rate_review</i>
              {{ "quoteTracking.quoteInquiry" | cxTranslate }}
            </h5>
          </div>
          <div
            class="col-md-12 inquiry-form-tab"
            *ngIf="displayFormHideMessage"
          >
            <form [formGroup]="inquiryForm">
              <span class="contact-txt"
                >{{ "quoteTracking.contactUs" | cxTranslate }}</span
              >
              <div class="inquiry-dropdown">
                <label
                  ><span class="label-content required"
                    >{{ "quoteTracking.inquiryType" | cxTranslate }}</span
                  ></label
                >
                <!-- <div class="dropdown"> -->
                  <ng-select
                    class="inquiry-type"
                    [searchable]="false"
                    [clearable]="false"
                    placeholder='{{ "quoteTracking.selectPlaceholder" | cxTranslate }}'
                    [ngClass]="
                      inquiryFormSubmitted && f.inquiryType.invalid
                        ? 'error-select'
                        : ''
                    "
                    formControlName="inquiryType"
                  >
                    <ng-option
                      *ngFor="let inquiry of inquiryTypes"
                      [value]="inquiry.code"
                      >{{ inquiry.name }}</ng-option
                    >
                  </ng-select>
                  <label
                    *ngIf="inquiryFormSubmitted && f.inquiryType.invalid"
                    class="error"
                  >
                  {{ "quoteTracking.validInquiry" | cxTranslate }}
                  </label>
                <!-- </div> -->
              </div>

              <div class="form-control-wrapper current-item-block">
                <span class="label-content required">{{ "quoteTracking.description" | cxTranslate }}</span>
                <textarea
                  type="text"
                  [ngClass]="
                    inquiryFormSubmitted && f.inquiryDescription.invalid
                      ? 'error-select'
                      : ''
                  "
                  formControlName="inquiryDescription"
                  class="form-control textareadesc"
                  maxlength="255"
                ></textarea>
                <label class="char-limit char-limit-count">{{ "quoteTracking.charLeft" | cxTranslate }}{{ 255 - inquiryForm.value.inquiryDescription?.length }}</label>
                <label
                  *ngIf="inquiryFormSubmitted && f.inquiryDescription.invalid"
                  class="error"
                >
                {{ "quoteTracking.enterDescription" | cxTranslate }}
                </label>
                <a
                  class="btn vs-primary-btn enq-btn"
                  (click)="
                    submitInquiry(
                      quoteDetail?.quoteDetailsList.quoteId,
                      quoteDetail?.quoteDetailsList.quoteReference,
                      quoteDetail?.quoteDetailsList.createdDate
                    )
                  "
                  >{{ "quoteTracking.submit" | cxTranslate }}</a
                >
              </div>
            </form>
          </div>
          <div
            class="col-lg-12 col-md-12 col-sm-12"
            *ngIf="!displayFormHideMessage"
          >
            <div class="success-txt-message">
              <em class="material-icons">check_circle</em>
              <span class="submittal-text">
                <strong class="part1"
                  >&nbsp;{{ "orderTracking.success" | cxTranslate }}</strong
                >&nbsp;
                <span class="part2">{{
                  "orderTracking.enquirySubmit" | cxTranslate
                }}</span></span
              >
            </div>
          </div>
          <!-- <div class="col-md-12">
            <div class="warning-message">
              <i class="material-icons">info</i><strong> Information </strong>
              <span class="obsolete-text">
                This is an obsolete product. Replacement products available.</span>
                <button
                  type="button"
                  class="close"
                  aria-label="Close">
                  <span aria-hidden="true">
                    <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
                  </span>
                </button>
            </div>
          </div> -->
        </div>
      </div>
      <div id="categoryFour" #categoryFour class="tabcontent">
        <div class="row custom-last-child-margin">
          <div class="col-md-12 add-content">
            <h5 class="tabcontent-display-line-section-heading title">
              <i class="line-icons line-item custom-margin-right-icon"></i>
              {{ "quoteTracking.lineItems" | cxTranslate }}
              <span
                class="expand-txt expndAll-size"
                (click)="expandAll = !expandAll"
                [ngClass]="{ expanded: expandAll }"
              >
                <i class="material-icons keyboard-arrow">keyboard_arrow_down</i>
                <span *ngIf="!expandAll">{{ "quoteTracking.expand" | cxTranslate }}</span>
                <span *ngIf="expandAll">{{ "quoteTracking.collapse" | cxTranslate }}</span>
              </span>
            </h5>
          </div>
          <div class="col-md-12">
            <vs-line-items
              [lineItems]="quoteDetail?.quoteLineDetails"
              [expandAll]="expandAll"
            ></vs-line-items>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<vs-quote-merge-footer-line
  *ngIf="
    quoteDetail?.quoteDetailsList.quoteStatusCode ===
      CurrentQuoteStatus.PENDING && quotes.length > 0
  "
  (updateQuotes)="updateQuotes($event)"
  [quotes]="quotes"
  [dateObject]="dateObject"
></vs-quote-merge-footer-line>
<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
